/** Estilos visuales compartidos (Muestra drawer) — sin lógica de negocio. */
import { alpha } from "@mui/material/styles";

/** Evita que el calendario quede debajo del accordion (overflow:hidden) / Drawer */
export const muestraDatePickerPortalProps = {
  portalId: "muestra-drawer-datepicker-portal",
  popperClassName: "muestra-drawer-datepicker-popper",
  popperProps: {
    strategy: "fixed",
  },
};

export function drawerAccordionSx(theme) {
  return {
    mb: 1.25,
    borderRadius: 2,
    border: `1px solid ${alpha(theme.palette.divider, 0.85)}`,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 2px 10px rgba(0,0,0,0.2)"
        : "0 2px 10px rgba(0,0,0,0.04)",
    "&:before": { display: "none" },
    backgroundColor: theme.palette.background.paper,
    overflow: "hidden",
  };
}

export function drawerAccordionSummarySx(theme) {
  const accent = theme.palette.primary.main;
  return {
    minHeight: 42,
    px: 1.5,
    borderRadius: 0,
    background:
      theme.palette.mode === "dark"
        ? `linear-gradient(135deg, ${alpha(accent, 0.18)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
        : `linear-gradient(135deg, ${alpha(accent, 0.1)} 0%, ${alpha(accent, 0.03)} 100%)`,
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
      gap: 1,
      my: 0.75,
      minWidth: 0,
    },
    "&.Mui-expanded": {
      minHeight: 42,
    },
  };
}

export function outlinedFieldSx(theme) {
  const surface =
    theme.palette.mode === "dark"
      ? theme.palette.background.cajaInpunts ||
        alpha(theme.palette.common.black, 0.28)
      : alpha(theme.palette.background.default, 0.72);

  return {
    "& .MuiInputBase-root": {
      backgroundColor: surface,
      color: theme.palette.text.primary,
      borderRadius: 1.5,
      fontSize: "0.875rem",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: alpha(theme.palette.divider, 0.85),
    },
    "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: alpha(theme.palette.primary.main, 0.45),
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary,
    },
    "& .MuiInputBase-input": {
      color: theme.palette.text.primary,
      paddingTop: "8.5px",
      paddingBottom: "8.5px",
    },
    "& .MuiSelect-select": {
      backgroundColor: "transparent",
    },
  };
}

/** Chip resumen en cabecera de acordeón */
export function sectionChipSx(theme) {
  return {
    height: 22,
    maxWidth: 140,
    fontWeight: 700,
    fontSize: "0.68rem",
    bgcolor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.text.primary,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.22)}`,
    "& .MuiChip-label": {
      px: 0.85,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };
}

const normalizeChipKey = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

/** Colores de estado — alineados con la lista de Muestras */
export function estadoChipSx(theme, estadoLabel) {
  const key = normalizeChipKey(estadoLabel);
  const colorMap = {
    "in design": "#c2185b",
    ordered: "#f9a825",
    "ok factory": "#2e7d32",
    sent: "#6a1b9a",
    canceled: "#b71c1c",
    cancelled: "#b71c1c",
    arrived: "#00838f",
    revised: "#0277bd",
    "sent to client": "#1565c0",
    approved: "#1b5e20",
    rejected: "#c62828",
    "pdte llegar": "#ef6c00",
  };
  const color = colorMap[key] || theme.palette.info.dark || "#455a64";

  return {
    height: 22,
    maxWidth: 160,
    fontWeight: 800,
    fontSize: "0.65rem",
    letterSpacing: 0.2,
    bgcolor: alpha(color, 0.14),
    color,
    border: `1px solid ${alpha(color, 0.42)}`,
    "& .MuiChip-label": {
      px: 0.85,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };
}

export function prioridadChipSx(theme, prioridad) {
  const colorMap = {
    Alta: "#c62828",
    Media: "#ef6c00",
    Normal: "#2e7d32",
  };
  const color = colorMap[prioridad] || theme.palette.grey[700];

  return {
    height: 22,
    maxWidth: 120,
    fontWeight: 800,
    fontSize: "0.65rem",
    bgcolor: alpha(color, 0.14),
    color,
    border: `1px solid ${alpha(color, 0.4)}`,
    "& .MuiChip-label": {
      px: 0.85,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };
}

export function marcaChipSx(theme) {
  const color = "#5e35b1";
  return {
    height: 22,
    maxWidth: 140,
    fontWeight: 800,
    fontSize: "0.65rem",
    bgcolor: alpha(color, 0.12),
    color,
    border: `1px solid ${alpha(color, 0.35)}`,
    "& .MuiChip-label": {
      px: 0.85,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };
}
